<template>
  <div>
    <Row
      type="flex"
      justify="end"
      :style="{
          position: 'absolute',
          top: '20px',
          right: '0px',
          zIndex: 100,
          width: '80vw'
        }"
    >
      <Col :md="16" style="text-align: center;">
        <h1 v-if="$mq == 'lg'">
          Live:
          <span
            style="color: green"
          >{{this.accountsData.filter(account => account.isTerminated === false).length}}</span>
          / Dead:
          <span
            style="color: red"
          >{{this.accountsData.filter(account => account.isTerminated === true).length}}</span>
          / Total:
          <span style="color: blue">{{this.accountsData.length}}</span>
        </h1>
      </Col>
      <Col :md="6" style="display:inline; text-align: right;">
        <Tooltip :content="isShowPassword ? 'Hide password and proxy' : 'Show password and proxy' " theme="light">
          <Button shape="circle" type="error" ghost :icon="isShowPassword ? 'md-eye-off' : 'md-eye' " @click="togglePassword"></Button>
        </Tooltip>
        <Button
          type="success"
          @click="addAccount"
          style="margin-left: 5px; margin-right: 10px;"
        >Add new account</Button>
      </Col>
    </Row>
    <Content>
      <h2 v-if="$mq != 'lg'" style="text-align: center;">
        Live:
        <span
          style="color: green"
        >{{this.accountsData.filter(account => account.isTerminated === false).length}}</span>
        / Dead:
        <span
          style="color: red"
        >{{this.accountsData.filter(account => account.isTerminated === true).length}}</span>
        / Total:
        <span style="color: blue">{{this.accountsData.length}}</span>
      </h2>
      <Table
        ref="selection"
        :border="false"
        :loading="loadingTable"
        :columns="tableHeader"
        :data="accountsData"
        :row-class-name="rowClassName"
        :max-height="860"
      >
        <template slot="password" slot-scope="{ row, index }">
          {{ isShowPassword ? row.passwordMerch : "************" }}
        </template>

        <template slot="proxy" slot-scope="{ row, index }">
          {{ isShowPassword ? row.proxy : "**********************" }}
        </template>

        <template slot="status" slot-scope="{ row, index }">
          {{ row.isTerminated ? "Dead" : "Live" }}
        </template>

        <template slot="action" slot-scope="{ row, index }">
          <Button
            v-if="row.isTerminated === true"
            type="dashed"
            size="small"
            disabled
          >Terminated</Button>
          <Button
            v-else
            type="error"
            size="small"
            ghost
            @click="killAccount(row.id)"
          >Kill</Button>
        </template>
      </Table>
    </Content>
    <Modal
      v-model="modalShow"
      title="Thông tin tài khoản Merch"
      width="450"
      class-name="account-add-modal"
    >
      <Row>
        <Col span="6" offset="1" style="padding-top: 8px;">
          <span>Number:</span>
        </Col>
        <Col span="16" offset="1">
          <InputNumber
            v-model="accountsInput.number"
            class="input-field"
            placeholder="Number"
            @on-blur="validateNumber"
          ></InputNumber>
          <p v-if="this.errorNumber" class="error-message">* This number already exists!</p>
        </Col>
      </Row>
      <br />
      <Row>
        <Col span="6" offset="1" style="padding-top: 8px;">
          <span>Username:</span>
        </Col>
        <Col span="16" offset="1">
          <Input v-model="accountsInput.username" class="input-field" placeholder="Username"></Input>
        </Col>
      </Row>
      <br />
      <Row>
        <Col span="6" offset="1" style="padding-top: 8px;">
          <span>Email password:</span>
        </Col>
        <Col span="16" offset="1">
          <Input
            v-model="accountsInput.passwordEmail"
            class="input-field"
            placeholder="Email password"
          ></Input>
        </Col>
      </Row>
      <br />
      <Row>
        <Col span="6" offset="1" style="padding-top: 8px;">
          <span>Merch password:</span>
        </Col>
        <Col span="16" offset="1">
          <Input
            v-model="accountsInput.passwordMerch"
            class="input-field"
            placeholder="Merch password"
          ></Input>
        </Col>
      </Row>
      <br />
      <Row>
        <Col span="6" offset="1" style="padding-top: 8px;">
          <span>Proxy:</span>
        </Col>
        <Col span="16" offset="1">
          <Input v-model="accountsInput.proxy" class="input-field" placeholder="Proxy"></Input>
        </Col>
      </Row>
      <br />
      <Row>
        <Col span="6" offset="1" style="padding-top: 8px;">
          <span>Proxy user:</span>
        </Col>
        <Col span="16" offset="1">
          <Input v-model="accountsInput.proxyUser" class="input-field" placeholder="Proxy user"></Input>
        </Col>
      </Row>
      <br />
      <Row>
        <Col span="6" offset="1" style="padding-top: 8px;">
          <span>Proxy password:</span>
        </Col>
        <Col span="16" offset="1">
          <Input v-model="accountsInput.proxyPass" class="input-field" placeholder="Proxy password"></Input>
        </Col>
      </Row>
      <div slot="footer">
        <Button size="large" @click="modalShow = false">Hủy bỏ</Button>
        <Button
          type="primary"
          size="large"
          :loading="modelOkLoading"
          @click="modalOk"
          :disabled="validateModal"
        >Đồng ý</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'Accounts',
  props: {},
  data() {
    return {
      tableHeader: [
        {
          title: 'Number',
          key: 'number',
          width: 90,
          align: 'center',
          minWidth: 90
        },
        {
          title: 'Username',
          key: 'username',
          minWidth: 300
        },
        {
          title: 'Password Merch',
          slot: 'password',
          width: 140,
          minWidth: 140
        },
        {
          title: 'Proxy',
          slot: 'proxy',
          width: 200,
          minWidth: 200
        },
        {
          title: 'Status',
          slot: 'status',
          width: 140,
          minWidth: 140,
          filters: [
            {
              label: 'Live',
              value: 1
            },
            {
              label: 'Dead',
              value: 2
            }
          ],
          filterMultiple: false,
          filterMethod (value, row) {
            if (value === 1) {
                return !row.isTerminated;
            } else if (value === 2) {
                return row.isTerminated;
            }
          },
          filteredValue: [1]
        },
        {
          title: 'Published',
          key: 'published',
          width: 100,
          align: 'center',
          minWidth: 100
        },
        {
          title: 'Tier',
          key: 'tier',
          width: 70,
          align: 'center',
          minWidth: 70
        },
        {
          title: 'Remaining',
          key: 'remaining',
          width: 100,
          align: 'center',
          minWidth: 100
        },
        {
          title: 'Action',
          slot: 'action',
          align: 'center',
          fixed: 'right',
          width: 100,
          minWidth: 100
        }
      ],
      accountsData: [],
      loadingTable: false,
      modalShow: false,
      accountsInput: {},
      editRowIndex: 0,
      isShowPassword: false,
      modelOkLoading: false,
      errorNumber: false,
      validateModal: true
    }
  },
  created() {
    if (
      !this.$store.state.accounts.accounts ||
      this.$store.state.accounts.accounts.length == 0
    ) {
      this.$store
        .dispatch('accounts/getAllAccounts')
        .then(res => {
          // console.log("data:", res.data);
          this.accountsData = this.$store.state.accounts.accounts
        })
        .catch(error => {
          console.debug(error)
          if (error.response.status === 401) {
            this.$Message.error('Không có quyền truy cập!')
          }
        })
    } else {
      this.accountsData = this.$store.state.accounts.accounts
    }
  },
  computed: {},
  methods: {
    rowClassName(row, index) {
      let rowClass = ''
      if (this.accountsData[index].isTerminated === true) {
        rowClass = 'table-error-row'
      } else {
        rowClass = 'table-success-row'
      }
      return rowClass
    },
    validateNumber() {
      api({
        method: 'get',
        url: '/accounts/exist',
        params: { number: this.accountsInput.number }
      })
        .then(response => {
          if (response.data.exist) {
            this.errorNumber = true
            this.validateModal = true
          } else {
            this.errorNumber = false
            this.validateModal = false
          }
        })
        .catch(error => {})
    },
    togglePassword() {
      this.isShowPassword = !this.isShowPassword
    },
    addAccount() {
      this.errorNumber = false
      this.accountsInput = {
        number: null,
        username: '',
        passwordEmail: '',
        passwordMerch: '',
        proxy: '',
        proxyUser: '',
        proxyPass: '',
        isTerminated: false
      }
      this.modalShow = true
    },
    modalOk() {
      let urlPath = '/accounts'
      let method = 'post'
      let title = 'Thêm tài khoản merch'
      let descOk = 'Thêm tài khoản merch thành công.'
      let descError = 'Thêm tài khoản merch lỗi.'
      let bodyData = Object.assign({}, this.accountsInput)
      api({
        method: method,
        url: urlPath,
        data: bodyData
      })
        .then(response => {
          this.$Notice.success({
            title: title,
            desc: descOk
          })
          this.accountsData.unshift(response.data)
          this.modalShow = false
        })
        .catch(error => {
          this.$Notice.error({
            title: title,
            desc: descError + '<br />' + error.message
          })
        })
        .finally(() => {
          this.modelOkLoading = false
        })
    },
    killAccount(accountId) {
      this.$Modal.confirm({
                    title: 'Tài khoản đã chết?',
                    content: '<p>Bạn có chắc chắn muốn đánh dấu tài khoản này là đã chết?</p>',
                    onOk: () => {
                      let urlPath = '/accounts/' + accountId
                      let method = 'put'
                      let title = 'Khóa tài khoản merch'
                      let descOk = 'Khóa tài khoản merch thành công.'
                      let descError = 'Khóa tài khoản merch lỗi.'
                      let bodyData = { isTerminated: true }
                      api({
                        method: method,
                        url: urlPath,
                        data: bodyData
                      })
                        .then(response => {
                          this.$Notice.success({
                            title: title,
                            desc: descOk
                          })
                          this.accountsData = this.accountsData.map(account => {
                            if (account.id == response.data.id) return response.data
                            else return account
                          })
                        })
                        .catch(error => {
                          this.$Notice.error({
                            title: title,
                            desc: descError + '<br />' + error.message
                          })
                        })
                    },
                    onCancel: () => {
                    }
                });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.ivu-table .table-success-row td {
  /* color: #006bf7; */
  font-weight: bold;
}
.ivu-table .table-error-row td {
  /* background-color: #c9c9c9; */
  color: #a7a7a7;
}
.account-add-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.account-add-modal .ivu-modal {
  top: 0;
}
.account-add-modal span {
  float: left;
}
.input-field {
  width: 250px;
}
.error-message {
  color: red;
  font-style: italic;
}
</style>
